import type { CellContext } from '@tanstack/vue-table';
import { h } from 'vue';
import OrderNumbers from './OrderNumbers.vue';

export const GetRelatedOrdersRenderer = () => {
  return (info: CellContext<any, any>) =>
    h(OrderNumbers, {
      key: `${info.row.original.id}-${info.row.original.orders}`,
      info,
    });
};
